import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import $ from 'jquery';

import pointer from "./Images/pointer.png"
import HomePage from './home';
import AboutPage from './about';
import CoursesPage from './courses';
import GalleryPage from './gallery';
import ContactPage from './contact';
import LoginPage from './login';
import RegisterPage from './register';

import File from './Comp';
import ApiFile from './OmdbApi';

import './style.css';
import logo from "./Images/projectLogo.png";

function App(){
    $(document).ready(()=>{
        $('.pointer').hide();
        $(window).scroll(()=>{
            // console.log($(window).scrollTop())
            if($(window).scrollTop() > 100){
                $('.pointer').fadeIn(200)
                $('.pointer').click(()=>{
                    $(window).scrollTop(0)
                })
            }else {
                $('.pointer').fadeOut(200)
            }
        })
        $('.footerLinks').click(()=>{
            $(window).scrollTop(1);
        })
    })
    return(
        <>
            <BrowserRouter>
                <img src={pointer} className="pointer" height="100" width="100" alt=""/>
                <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
                        <div className="container-fluid">
                        <Link className="navbar-brand m-auto fs-3" to="https://www.stanford.edu/" target="__block">
                            <img height="38px" src={logo} alt=""/>
                            <span className="logoName ps-2">Stanford University</span>
                        </Link>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mb-2 mb-lg-0 ps-5 m-auto">
                                <li className="nav-item">
                                <Link
                                    className="nav-link fs-5 fw-bold px-4 ms-2 active"
                                    aria-current="page"
                                    to="/">HOME</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link fs-5 px-4 ms-2" to="/about">ABOUT US</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link fs-5 px-4 ms-2" to="/courses">COURSES</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link fs-5 px-4 ms-2" to="/gallery">GALLERY</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link fs-5 px-4 ms-2" to="/contact">CONTACT US</Link>
                                </li>
                                <li className="nav-item">
                                    <Link className="nav-link fs-5 px-4 ms-2" to="/OmdbApi">API</Link>
                                </li>
                            </ul>
                            <ul className="navbar-nav mb-2 mb-lg-0 ps-5 m-auto">
                                <li className="nav-item">
                                    <Link className="nav-link fs-5 px-4 ms-2" to="/login">LOGIN</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <Routes>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/about" element={<AboutPage/>}/>
                    <Route path="/courses" element={<CoursesPage/>}/>
                    <Route path="/gallery" element={<GalleryPage/>}/>
                    <Route path="/contact" element={<ContactPage/>}/>
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/register" element={<RegisterPage/>}/>
                    <Route path="/abc" element={<File/>}/>
                    <Route path="/OmdbApi" element={<ApiFile/>}/>
                </Routes>
                <div className="container-fluid footer mb-0 p-5 headingCls">
                <div className="row px-3">
                    <div className="col-xl-4 col-md-12">
                        <div className="row fs-2 text-light mt-3 mb-4">Follow Us</div>
                        <div className="row">We look for distinctive students who exhibit an abundance of energy and curiosity in their classNamees, activities, projects, research, and lives.</div>
                        <div className="row">
                            <div className="col-10 offset-xl-1 mt-3">
                                <Link to="https://twitter.com/stanford" className="footerLinks"><i className="fa-brands fa-twitter fs-1 me-2"></i></Link>
                                <Link to="https://www.facebook.com/stanford" className="footerLinks"><i className="fa-brands fa-facebook fs-1 me-2"></i></Link>
                                <Link to="https://www.instagram.com/stanford/" className="footerLinks"><i className="fa-brands fa-instagram fs-1 me-2"></i></Link>
                                <Link to="https://www.linkedin.com/school/stanford-university/" className="footerLinks"><i className="fa-brands fa-linkedin fs-1 me-2"></i></Link>
                                <Link to="https://www.youtube.com/stanford" className="footerLinks"><i className="fa-brands fa-youtube fs-1 me-2"></i></Link>
                                <Link to="https://podcasts.apple.com/us/artist/stanford/1280771285" className="footerLinks"><i className="fa-brands fa-apple fs-1 me-2"></i></Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-1 col-md-6 ps-3">
                        <div className="row fs-2 text-light mt-3 mb-4">Links</div>
                        <div className="row mt-1"><Link to="/" className="footerLinks">Home</Link></div>
                        <div className="row mt-1"><Link to="about" className="footerLinks">About Us</Link></div>
                        <div className="row mt-1"><Link to="courses" className="footerLinks">Courses</Link></div>
                        <div className="row mt-1"><Link to="gallery" className="footerLinks">Gallery</Link></div>
                        <div className="row mt-1"><Link to="contact" className="footerLinks">Contact</Link></div>
                    </div>
                    <div className="col-xl-3 col-md-6 ps-5">
                        <div className="row fs-2 text-light mt-3 mb-3 ms-5">Resources</div>
                        <div className="row ps-2">
                            <div className="col-xl-4 col-md-6"> 
                                <div className="row mt-1">Clients</div>
                                <div className="row mt-1">Team</div>
                                <div className="row mt-1">Career</div>
                                <div className="row mt-1">Testimonials</div>
                                <div className="row mt-1">Journal</div>
                            </div>
                            <div className="col-xl-8 col-md-6">
                                <div className="row mt-1">Privacy Policy</div>
                                <div className="row mt-1">Terms and Conditions</div>
                                <div className="row mt-1">Partners</div>
                            </div>
                        </div> 
                    </div>
                    <div className="col-xl-4 col-md-12 ps-5">
                        <div className="row fs-2 text-light mt-3 mb-2">Have a Questions?</div>
                        <div className="row">
                            <div className="row mt-3">
                                <div className="col-xl-1"><i className="fa-solid fa-location-dot"></i></div>
                                <div className="col-xl-11">203, Fake St. Mountain View, San Francisco, California, USA</div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-xl-1"><i className="fa-solid fa-phone"></i></div>
                                <div className="col-xl-11">+2 854 678 111</div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-xl-1"><i className="fa-solid fa-paper-plane"></i></div>
                                <div className="col-xl-11">school@gmail.com</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-5"><hr/></div>
                <div className="row mt-3">
                    <div className="col-md-12 text-center fs-4 text-light">
                        &copy; 2023 - All Rights Reserved
                    </div>
                </div>
            </div>
            </BrowserRouter>
        </>
    )
}
export default App